import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  CircularProgress,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { Link, useLocation, useNavigate } from "react-router-dom";
import apiClient from "../utlis/apiClient";
import PaginationComponent from "../Common/PaginationComponent";

const ManageTools = () => {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const ToolsName = location.state?.ToolsName || "";
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  console.log(ToolsName," the tools name");
  console.log(location.state?.ToolsName," the tools name");

  useEffect(() => {
    if (ToolsName) {
      setSearchQuery(ToolsName);
    } else {
      setSearchQuery("");
    }
    fetchToolsData();
  }, [ToolsName]);


  const fetchToolsData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get(`/api/tools/get-all-tools`);
      console.log("API Response:", response.data.data);
      setTools(response.data.data);
    } catch (error) {
      console.error("Error fetching Tools data:", error);
      setError("Failed to fetch tools data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };



  const filteredItems = tools.filter(
    (tool) =>
      tool.Name && tool.Name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortDataByName = (data) => {
    return data.sort((a, b) => a.Name.localeCompare(b.Name));
  };

  const sortedFilteredItems = sortDataByName(filteredItems);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#325c67",
      color: theme.palette.common.white,
      padding: "10px",
      verticalAlign: "top",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: "10px !important",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f3f3f3",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleEditClick = (pk) => {
    navigate("/UpdateTools", { state: { pk } });
  };

  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <SubHeader />
      <Grid
        container
        sx={{ flexGrow: 1, marginTop: "-80px", padding: 0 }}
        spacing={6}
      >

        <Grid item xs={12} md={11}>
          <Box
            sx={{
              minHeight: "calc(100vh - 112px)",
              backgroundColor: "white",
              padding: 2,
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              marginLeft: "150px",
            }}
          >
            <Grid
              container
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  Tools Details
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  size="small"
                  component={Link}
                  to="/AddTools"
                >
                  Add Tools
                </Button>
              </Grid>
            </Grid>

            {error && (
              <Typography color="error" variant="body2" gutterBottom>
                {error}
              </Typography>
            )}

            <TableContainer component={Paper} sx={{ marginTop: 4 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>SNO</StyledTableCell>
                    <StyledTableCell>Description</StyledTableCell>
                    <StyledTableCell>Type</StyledTableCell>
                  
                    {/* <StyledTableCell>Size</StyledTableCell> */}
               
                    <StyledTableCell>Quantity</StyledTableCell>
                    <StyledTableCell>Composition</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : sortedFilteredItems.length > 0 ? (
                    sortedFilteredItems
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((tool, index) => (
                      <StyledTableRow key={tool.PK}>
                        <StyledTableCell>{index + 1}</StyledTableCell>
                        <StyledTableCell>{tool.Name}</StyledTableCell>
                        <StyledTableCell>{tool.Values?.Tools}</StyledTableCell>
                 
                        {/* <StyledTableCell>{tool.Values?.Size}</StyledTableCell> */}
                    
                        <StyledTableCell>{tool.Quantity}</StyledTableCell>
                        <StyledTableCell>{tool.Values?.Composition}</StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        There Are No Tools Records.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <PaginationComponent count={sortedFilteredItems.length} page={page} rowsPerPage={rowsPerPage} onPageChange={handleChangePage} />
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ManageTools;
